import { render, staticRenderFns } from "./OnlCgformCopyList.vue?vue&type=template&id=0892f48b&scoped=true&"
import script from "./OnlCgformCopyList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformCopyList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformCopyList.vue?vue&type=style&index=0&id=0892f48b&scoped=true&lang=css&"
import style1 from "./OnlCgformCopyList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892f48b",
  null
  
)

export default component.exports